<template>
  <BTableSimple
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    v-on="$listeners || {}"
  >
    <template #item.name="{ header, item }">
      <router-link
        :to="header.getRoute(item)"
        v-text="item.name"
      />
    </template>
  </BTableSimple>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/UsersParticipants/table-headers'
import BTableSimple from '@/components/tables/BTableCommon/BTableSimple.vue'


export default {
  name: 'BTableUsersParticipants',
  components: {
    BTableSimple,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
